import Component from './component'
import {connect} from 'react-redux'

const stateTo = (state) =>({
    texto : function(){
        let ds = state.database.paginas;
        let as = ds.get(ds.findIndex(x=>x.get('id')=='1531259421609'))
        if(as) return as.get('conteudo')
        else return ''
    }() 
})

export default connect(stateTo)(Component)


// WEBPACK FOOTER //
// ./src/views/website/header/conteudo/container.js